export const SET_CLIENT_AREA = 'LIST_CLIENTS/SET_CLIENT_AREA';
export const SET_CLIENT_AREA_PLANS = 'LIST_CLIENTS/SET_CLIENT_AREA_PLANS';
export const CLEAR_CLIENT_AREA = 'LIST_CLIENTS/CLEAR_CLIENT_AREA';
export const HANDLE_LOADING = 'LIST_CLIENTS/HANDLE_LOADING';
export const HANDLE_PLANS_LOADING = 'LIST_CLIENTS/HANDLE_PLANS_LOADING';
export const HANDLE_SEND_EMAIL_LOADING = 'LIST_CLIENTS/HANDLE_SEND_EMAIL_LOADING';